import ManageClass from './ManageClass';

export default ManageClass;
